export default __webpack_public_path__ + "static/media/carousel5.35edecdd.jpg";